module.exports = __webpack_public_path__ + "static/img/learn.8114337.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/risk/learn.png
// module id = TwvF
// module chunks = 16